import { render, staticRenderFns } from "./HorizontalHeader.vue?vue&type=template&id=4b24863a&scoped=true"
import script from "./HorizontalHeader.vue?vue&type=script&lang=js"
export * from "./HorizontalHeader.vue?vue&type=script&lang=js"
import style0 from "./HorizontalHeader.vue?vue&type=style&index=0&id=4b24863a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b24863a",
  null
  
)

export default component.exports